export default "__VITE_ASSET__c9757d0a__"